module.exports = __webpack_public_path__ + "static/media/statistics-animation.79246cb8.gif";